var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHierarchy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 18.6875V13.8125H13.8125V10.5625H17.875V0.8125H8.125V10.5625H12.1875V13.8125H3.25V18.6875H0.8125V25.1875H7.3125V18.6875H4.875V15.4375H12.1875V18.6875H9.75V25.1875H16.25V18.6875H13.8125V15.4375H21.125V18.6875H18.6875V25.1875H25.1875V18.6875H22.75ZM9.75 2.4375H16.25V8.9375H9.75V2.4375ZM5.6875 23.5625H2.4375V20.3125H5.6875V23.5625ZM14.625 20.3125V23.5625H11.375V20.3125H14.625ZM23.5625 23.5625H20.3125V20.3125H23.5625V23.5625Z",
    fill: "#00CBAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHierarchy);
export default __webpack_public_path__ + "static/media/hierarchy.8951fcfcdd9fe3954a05459707b22f51.svg";
export { ForwardRef as ReactComponent };